// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nT-z","hovered":"oT-z","hoverImage":"pT-z","mainImage":"qT-z","imageNoBackground":"rT-z","fullSizeImage":"sT-z"};